var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RelationshipSelector = function () {
    function RelationshipSelector(InsuranceSuiteMetadata) {
        _classCallCheck(this, RelationshipSelector);

        this._typelist = InsuranceSuiteMetadata.get('pc').types.getTypelist('AccountRelationshipType');
        this.relationships = this._typelist.codes.map(function (c) {
            return { code: c.code, name: 'gateway.contacts.AccountRelationshipType.typekey.' + c.code };
        });
    }

    _createClass(RelationshipSelector, [{
        key: 'onRelChange',
        value: function onRelChange(code) {
            this.onChange({ value: code });
        }
    }]);

    return RelationshipSelector;
}();

RelationshipSelector.$inject = ['InsuranceSuiteMetadata'];

export default RelationshipSelector;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/contacts/common/components/RelationshipSelector/RelationshipSelector.js
// module id = 1632
// module chunks = 0